import { IFilteringExpressionsTree, ISortingExpression } from '@infragistics/igniteui-angular';

import { BaseModel } from '../../core/abstractions/base.model';

export class SearchRequestModel extends BaseModel {
    searchString?: string;
    page?: number;
    pageSize?: number;
    filters?: IFilteringExpressionsTree;
    sortings?: ISortingExpression[];

    constructor(init?: Partial<SearchRequestModel>) {
        super();
        Object.assign(this, init);
    }
}
